/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: 'xl' },
      tokens: { contentMaxDimension: 168, imageDimension: 168 }
    },
    {
      if: { hover: true },
      tokens: { color: '#394056', imageDimension: 140, textLine: 'underline' }
    },
    {
      if: { focus: true },
      tokens: {
        color: '#636c8c',
        outerBorderColor: '#636c8c',
        textLine: 'underline'
      }
    },
    {
      if: { pressed: true },
      tokens: {
        color: '#2b3145',
        outerBorderColor: '#2b3145',
        textLine: 'none'
      }
    }
  ],
  tokens: {
    color: '#636c8c',
    contentAlignItems: 'center',
    contentDirection: 'column',
    contentMaxDimension: 140,
    contentSpace: 3,
    fontName: 'SofiaPro',
    fontSize: 18,
    fontWeight: '700',
    gap: 5,
    imageDimension: 140,
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    textAlign: 'center',
    textLine: 'none'
  }
}
export default theme
